<div class="input-filter" (click)="toggleTimepicker()" [class.active]="!!value">
  <fieldset class="input">
    <legend></legend>
    <label [class.active]="!!value" for="">{{initialPlaceHolder}}</label>
    <input type="text" [placeholder]="initialPlaceHolder" [value]="value" disabled>
  </fieldset>
  <i aria-hidden="true" class="icon-arrow-drop-up"></i>
</div>

<ng-container>
  <app-swipe-up
    [heightPercentaje]="100"
    [showSwipeUp]="showSwipeUp"
    (toggleShowSwipeUp)="toggleTimepicker()">
    <ng-container content *ngIf="showSwipeUp">
      <ng-container content *ngTemplateOutlet="timepickerContent"></ng-container>
    </ng-container>
  </app-swipe-up>
</ng-container>

<ng-template #timepickerContent>
  <div class="timepicker-content" #timepickerMatrix>
    <div class="timepicker-title">{{ initialPlaceHolder }}</div>
    <div class="timepicker-selector">
      <app-ds-data-picker
        [data]="dataPickerModel"
        (changedEvent)="updateTime($event)">
      </app-ds-data-picker>
    </div>
    <div class="timepicker-action">
      <button class="timepicket-cancel" (click)="toggleTimepicker()">
        {{'CANCEL' | transloco}}
      </button>
      <button class="timepicker-apply" (click)="applyTime()">
        {{'BUTTONS.CONFIRM' | transloco}}
      </button>
    </div>
  </div>
</ng-template>
